import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CardAction from '../../../../../../../../components/card/CardAction';
import ConfirmationDialog from '../../../../../../../../components/dialog/ConfirmationDialog';
import './DeleteFileAction.scss';

export default function DeleteFileAction({
  onConfirm,
  disabled,
  isDeleting,
  ariaLabel,
  className,
} = {
  className: '',
  onConfirm: () => null,
  disabled: true,
  isDeleting: false,
  ariaLabel: 'Delete',
}) {
  const [state, setState] = useState({
    dialogOpen: false,
  });

  const handleClickOpen = () => {
    setState({
      ...state,
      dialogOpen: true,
    });
  };

  const handleOnClose = () => {
    setState({
      ...state,
      dialogOpen: false,
    });
  };

  return (
    <>
      <CardAction
        icon={<DeleteIcon aria-hidden='false' />}
        actionHandler={() => { handleClickOpen(); }}
        label='Delete'
        className={`btn-danger delete-file-action ${className}`}
        ariaLabel={ariaLabel}
        title={ariaLabel}
        data-test='delete-file-action'
        disabled={disabled}
        tabIndex={0}
        aria-hidden='false'
      />
      <ConfirmationDialog
        open={state.dialogOpen}
        title='Delete files'
        loading={isDeleting}
        contentText={(
          <Box display='flex' width='300px' flexDirection='column' justifyContent='center'>
            <Typography variant='body1'>
              Are you sure?
            </Typography>
            <br />
            <Typography variant='body1'>
              All selected files will be deleted.
            </Typography>
          </Box>
        )}
        confirmLabel='Yes'
        cancelLabel='Cancel'
        onConfirm={async () => {
          await onConfirm();
          handleOnClose();
        }}
        onCancel={() => { handleOnClose(); }}
        confirmClass='wide-button'
        cancelClass='wide-button'
      />
    </>
  );
}
